export const CURRENCIES = {
  EUR: `€` as const,
  USD: `$` as const,
  GBP: `£` as const,
  JPY: `¥` as const,
  AUD: `A$` as const,
  CAD: `C$` as const,
  CHF: `CHF` as const,
  CNY: `¥` as const,
  NZD: `NZ$` as const,
  KRW: `₩` as const,
  INR: `₹` as const,
  RUB: `₽` as const,
  BRL: `R$` as const,
  MXN: `$` as const,
  SGD: `S$` as const,
};

export type Currency = keyof typeof CURRENCIES;

export const ALLOWED_CURRENCIES = [
  `EUR`,
  `USD`,
  `GBP`,
  `JPY`,
  `AUD`,
  `CAD`,
  `CHF`,
  `CNY`,
  `NZD`,
  `KRW`,
  `INR`,
  `RUB`,
  `BRL`,
  `MXN`,
  `SGD`,
] as const;

export const CURRENCY_OPTIONS = [
  { value: `EUR`, label: `€` },
  { value: `USD`, label: `$` },
  { value: `GBP`, label: `£` },
  { value: `JPY`, label: `¥` },
  { value: `AUD`, label: `A$` },
  { value: `CAD`, label: `C$` },
  { value: `CHF`, label: `CHF` },
  { value: `CNY`, label: `¥` },
  { value: `NZD`, label: `NZ$` },
  { value: `KRW`, label: `₩` },
  { value: `INR`, label: `₹` },
  { value: `RUB`, label: `₽` },
  { value: `BRL`, label: `R$` },
  { value: `MXN`, label: `$` },
  { value: `SGD`, label: `S$` },
] as { value: Currency; label: string }[];

export const CURRENCY_SYMBOLS = CURRENCY_OPTIONS.map((option) => option.label);
